var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"transparent-button",on:{"click":_vm.emitClick}},[(_vm.icon)?_c('span',{staticClass:"transparent-button__icon",domProps:{"innerHTML":_vm._s(_vm.icon)}}):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }